import { intl } from "LocaleWrapper";
import LocationSelect, { LocationSelectOption, LocationSelectProps } from "./LocationSelect";
import { Box } from "@mui/material";
import { Checkbox } from "@cofano/cck";

export type LocationWithSubLocationsSelectOption = {
	locations: LocationSelectOption[];
	includeSubLocations: boolean;
};

const LocationWithSubLocationsSelect = ({ value, onChange, ...rest }: {
	value: LocationWithSubLocationsSelectOption | null;
	onChange: (value: LocationWithSubLocationsSelectOption | null) => void;
} & Omit<LocationSelectProps<true>, "multiple" | "value" | "onChange">) => {

	const emit = (locations: LocationSelectOption[] | null, nextIncludeGroups: boolean) => {
		if (!locations || locations.length === 0) {
			onChange(null);
		} else {
			onChange({ locations, includeSubLocations: nextIncludeGroups });
		}
	};

	return (
		<Box position="relative">
			<Box
				component="span"
				sx={{
					position: "absolute",
					top: rest.label ? 0 : "-19px",
					right: 0,
					zIndex: 1,
					opacity: 0.8,
					fontSize: "12px",
					transform: "scale(0.9)",
					transformOrigin: "right center",
				}}
			>
				<Checkbox
					label={intl.formatMessage({ id: "INCLUDE_SUB_LOCATIONS" })}
					checked={value?.includeSubLocations}
					onChange={(event) => emit(value?.locations ?? null, event.target.checked ?? false)}
					size="small"
				/>
			</Box>
			<LocationSelect
				{...rest}
				value={value?.locations ?? null}
				multiple
				onChange={(locations) => emit(locations, value?.includeSubLocations ?? false)}
			/>
		</Box>
	);
};

export default LocationWithSubLocationsSelect;
